import axios from 'axios';
import ResponseErrorHandel from "../ReponseErrorHandeler/StatusHandel.js";


const apiRequests = axios.create({
    baseURL: "https://api.goalafarin.com",
    headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    },
    timeout: 10000,
})

export default apiRequests;


apiRequests.interceptors.request.use(
    config => {
        return config
    },
    error => {
        console.log("error ", error);
        return Promise.reject(error)
    }
)


apiRequests.interceptors.response.use(
    (res) => {
        return res
    },

    error => {
        ResponseErrorHandel(error)
        return Promise.reject(error)

    }
)



